'use strict';

const RAD_PER_DEG = 0.0174532925199433; // PI / 180
const EARTH_RADIUS_IN_M = 6371000;

export default class GpsUtils {
  static distanceBetweenPoints(a, b) {
    if (typeof(a) === 'undefined' || typeof(b) === 'undefined') {
      return 0;
    }

    // converts delta to rad
    const dlon_rad = (b.lng - a.lng) * RAD_PER_DEG;
    const dlat_rad = (b.lat - a.lat) * RAD_PER_DEG;
    const lat1_rad = a.lat * RAD_PER_DEG;
    const lat2_rad = b.lat * RAD_PER_DEG;

    const x = Math.pow(Math.sin(dlat_rad / 2), 2) + Math.cos(lat1_rad) * Math.cos(lat2_rad) * Math.pow(Math.sin(dlon_rad / 2), 2);
    const c = 2 * Math.asin(Math.sqrt(x));

    return EARTH_RADIUS_IN_M * c;
  }
}
